import { render, staticRenderFns } from "./inRecords.vue?vue&type=template&id=dcf745c4&scoped=true&"
import script from "./inRecords.vue?vue&type=script&lang=js&"
export * from "./inRecords.vue?vue&type=script&lang=js&"
import style0 from "./inRecords.vue?vue&type=style&index=0&id=dcf745c4&lang=less&scoped=true&"
import style1 from "./inRecords.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf745c4",
  null
  
)

component.options.__file = "inRecords.vue"
export default component.exports